export default __webpack_public_path__ + "static/venue-1-b37d5550c3e002e20ff953c07ed9eade.jpg";